import React from 'react'
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
const WebSpecification = () => {
  return (
     <>
    
             {/* <p className="text-5xl font-bold text-center mb-12">Process of Developing Website</p>
             <div className="grid grid-cols-2 sm:grid-cols-2  md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8 max-w-xl mx-auto md:max-w-3xl lg:max-w-full">
                   <div  className="pt-3 pb-3 block group bg-transparent border border-indigo-600 shadow-lg hover:shadow-2xl transition-shadow duration-300 rounded-lg" >
                           
                        <div className="relative mb-6">
                         <img
                              src=""
                              alt=""
                              className="w-20 h-20 rounded-full mx-auto transition-all duration-500 object-cover border border-solid border-transparent group-hover:border-indigo-600 "
                         />
                           <h4 className="text-md font-semibold text-white-900 mb-1 capitalize text-center transition-all duration-500 group-hover:text-white-600">
                                   Planning and strategy   
                           </h4>
                      </div>

                 </div>
             </div> */}
             <>
  <p className="text-5xl font-bold text-center mb-12">Phases of Website Development</p>

  <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto ">
    {/* Card 1 */}
    <div className="pt-3 pb-3 block group bg-transparent border border-indigo-600 shadow-lg hover:shadow-2xl transition-shadow duration-300 rounded-lg ">
      <div className="relative mb-6 px-3">
         <span className="inline-block mb-4 text-sm font-semibold text-white bg-indigo-600 px-3 py-1 rounded-full text-center mx-auto">
        Step 1
         </span>
        <DotLottieReact
      src="https://lottie.host/914f58e8-bdc2-4eca-b617-629bd00cf3f6/btktXFk7sc.lottie"
      loop
      autoplay
    />
        <h4 className="text-lg font-semibold text-white-900 mb-1 capitalize text-center transition-all duration-500 group-hover:text-white-600">
          Planning and strategy
        </h4>
         <p className="text-md text-center text-white-700 px-4 mt-2">
              Effective web application development begins with a comprehensive planning and strategy phase. This step ensures your project is aligned with business goals, user expectations, and current digital trends.
            </p>
      </div>
    </div>

    {/* Card 2 */}
    <div className="pt-3 pb-3 block group bg-transparent border border-indigo-600 shadow-lg hover:shadow-2xl transition-shadow duration-300 rounded-lg">
      <div className="relative mb-6 px-3">
         <span className="inline-block mb-4 text-sm font-semibold text-white bg-indigo-600 px-3 py-1 rounded-full text-center mx-auto">
        Step 2
         </span>
       <DotLottieReact
      src="https://lottie.host/831065a6-e5ed-470b-b0cf-b2fe2f18abae/EKyu7ARNzQ.lottie"
      loop
      autoplay
    />
        <h4 className="text-lg font-semibold text-white-900 mb-1 capitalize text-center transition-all duration-500 group-hover:text-white-600">
          Design and Development
        </h4>
         <p className="text-md text-center text-white-700 px-4 mt-2">
             Web design and development process focuses on building fast, responsive, and scalable digital experiences that engage users and support business growth. We transform your ideas into powerful web applications and custom websites using the latest technologies and best development practices.

            </p>
           
      </div>
    </div>

    {/* Card 3 */}
    <div className="pt-3 pb-3 block group bg-transparent border border-indigo-600 shadow-lg hover:shadow-2xl transition-shadow duration-300 rounded-lg">
      <div className="relative mb-6 px-3">
         <span className="inline-block mb-4 text-sm font-semibold text-white bg-indigo-600 px-3 py-1 rounded-full text-center mx-auto">
        Step 3
         </span>
       <DotLottieReact
      src="https://lottie.host/9dd94b8f-8219-4ae7-86d8-07a31306fb8b/FnUeCsYQLo.lottie"
      loop
      autoplay
    />
        <h4 className="text-lg font-semibold text-white-900 mb-1 capitalize text-center transition-all duration-500 group-hover:text-white-600">
          Testing and Deployment
        </h4>
         <p className="text-md text-center text-white-700 px-4 mt-2">
             Web development process isn’t complete without through testing and deployment. We ensure your website or web application is secure, bug-free, optimized for speed, and ready for a successful launch. This phase is critical for ensuring top performance, cross-browser compatibility, and long-term scalability.
            </p>
      </div>
    </div>
  </div>
</>

            
     </>
    
  )
}

export default WebSpecification